import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const DialogWrapper = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;
export const ModalContainer = styled.div`
  position: relative;
  background-color: ${customPalette.accent.white};
  padding: 24px;
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;
export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
  color: ${customPalette.accent.main};
`;
export const ModalContent = styled.div`
  font-size: 14px;
  color: ${customPalette.grey[800]};
  margin: 16px 0;
`;
export const ModalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;
export const ModalLabel = styled.span`
  font-size: 14px;
  color: ${customPalette.grey[800]};
`;
export const ModalValue = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${customPalette.accent.main};
`;
export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${customPalette.grey[200]};
  margin: 16px 0;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
`;
export const BoldSpan = styled.span`
  font-weight: 700;
`;
